import { AlertCircle, RotateCcw } from "lucide-react";

/**
 * Compact error row for an InfoPanel. Shown when usePanelData's fetch
 * rejected — gives the user a clear failure signal + a one-click retry,
 * instead of the old behaviour where a failed fetch silently rendered
 * the empty state ("No tasks yet" even though the API returned 500).
 */
export function PanelErrorRow({
  message,
  onRetry,
}: {
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="flex items-start gap-2 px-3 py-3 text-xs">
      <AlertCircle className="h-3.5 w-3.5 shrink-0 text-rose-400" />
      <div className="min-w-0 flex-1">
        <p className="text-rose-300">Couldn't load this section.</p>
        {message && <p className="mt-0.5 truncate text-zinc-500">{message}</p>}
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex shrink-0 items-center gap-1 rounded px-1.5 py-0.5 text-zinc-400 hover:bg-zinc-800/60 hover:text-zinc-200"
        >
          <RotateCcw className="h-3 w-3" />
          Retry
        </button>
      )}
    </div>
  );
}
